const DISABLED = []; //SKUs that are temporarily disabled

const subscribeProductCache = {};
const subscribeProductPending = {};
window.subscribeSelectorState = window.subscribeSelectorState || {
    packSize: null,
    sellingPlanKey: null,
};

function getPackSize(variant) {
    const match = String(variant?.title || '').match(/(\d+)\s*-?\s*Pack/i);
    return match ? parseInt(match[1], 10) : 1;
}

function formatPrice(price) {
    const cents = Number(price);
    if (!Number.isFinite(cents)) return '$0.00';
    return `$${(cents / 100).toFixed(2)}`;
}

function calculatePrice(price, selling_plan, format = true) {
    let newPrice = Number(price);
    if (!selling_plan?.price_adjustments?.[0]) {
        return format ? formatPrice(newPrice) : newPrice;
    }
    if (selling_plan.price_adjustments[0].value_type === 'percentage') {
        const perc = 100 - selling_plan.price_adjustments[0].value;
        newPrice = Math.round(newPrice * perc / 100);
    } else {
        newPrice = newPrice - selling_plan.price_adjustments[0].value;
    }
    return format ? formatPrice(newPrice) : newPrice;
}

function productImage(product) {
    const featured = product?.featured_image;
    if (typeof featured === 'string' && featured) return featured;
    if (featured?.src) return featured.src;
    const first = product?.images?.[0];
    if (typeof first === 'string' && first) return first;
    if (first?.src) return first.src;
    return '';
}

function selectorProductTitle(product) {
    let title = String(product.title || '').replace(/Glass/gi, '').replace(/\s+/g, ' ').trim();
    const paren = title.match(/\(([^)]+)\)/);
    const sizeLabel = paren ? `(${paren[1]})` : '';
    let name = title.replace(/\s*\([^)]*\)\s*/g, '').trim();
    const type = product.type || '';
    if (type && !name.toLowerCase().includes(String(type).toLowerCase())) {
        name = `${name} ${type}`.trim();
    }
    return { name, sizeLabel };
}

function formatPackLabel(variant) {
    const size = getPackSize(variant);
    return size > 1 ? `${size} Pack` : (variant.title || 'Pack');
}

function formatFrequencyLabel(plan) {
    const name = String(plan?.name || '');
    const daysMatch = name.match(/(\d+)\s*days?/i);
    const weeksMatch = name.match(/(\d+)\s*weeks?/i);
    let days = null;
    if (daysMatch) days = parseInt(daysMatch[1], 10);
    else if (weeksMatch) days = parseInt(weeksMatch[1], 10) * 7;
    else if (/every\s+week(?!s)/i.test(name)) days = 7;
    else if (/month/i.test(name)) return 'Every Month';

    if (days === 7) return 'Every Week';
    if (days === 14) return 'Every 2 Weeks';
    if (days === 21) return 'Every 3 Weeks';
    if (days === 28 || days === 30 || days === 31) return 'Every Month';
    if (days && days % 7 === 0) return `Every ${days / 7} Weeks`;
    if (days) return `Every ${days} Days`;
    return name.replace(/^(delivery|deliver(ed)?)\s+/i, '').trim() || name;
}

function planMatchKey(plan) {
    return formatFrequencyLabel(plan).toLowerCase();
}

function sellingPlans(product) {
    return product?.selling_plan_groups?.[0]?.selling_plans || [];
}

function pickSelectorVariant(variants) {
    const available = (variants || []).filter((variant) => variant.available && !DISABLED.includes(variant.sku));
    const pool = available.length ? available : (variants || []);
    const pack = window.subscribeSelectorState.packSize;
    if (pack) {
        const match = pool.find((variant) => getPackSize(variant) === pack);
        if (match) return match;
    }
    return pool[pool.length - 1] || variants?.[0];
}

function pickSelectorPlan(plans) {
    if (!plans?.length) return null;
    const key = window.subscribeSelectorState.sellingPlanKey;
    if (key) {
        const match = plans.find((plan) => planMatchKey(plan) === key);
        if (match) return match;
    }
    return plans.find((plan) => /14|2\s*week/i.test(plan.name || '')) || plans[0];
}

function getSubscriptionPrice(variant, plan) {
    if (!variant) return 0;
    if (!plan) return Number(variant.price) || 0;
    const alloc = variant.selling_plan_allocations?.find(
        (entry) => String(entry.selling_plan_id) === String(plan.id)
    );
    if (alloc && alloc.price != null) return Number(alloc.price);
    return Number(calculatePrice(variant.price, plan, false));
}

function saveSelectorState(picker, product) {
    const variants = product?.variants || [];
    const plans = sellingPlans(product);
    const idField = picker.querySelector('[name="id"]');
    const variant = variants.find((entry) => String(entry.id) === String(idField?.value)) || pickSelectorVariant(variants);
    const planField = picker.querySelector('[name="selling_plan"]');
    const plan = plans.find((entry) => String(entry.id) === String(planField?.value)) || pickSelectorPlan(plans);
    if (variant) window.subscribeSelectorState.packSize = getPackSize(variant);
    if (plan) window.subscribeSelectorState.sellingPlanKey = planMatchKey(plan);
}

function cacheEmbeddedSelectorProducts() {
    document.querySelectorAll('[data-subscribe-product-json]').forEach((el) => {
        try {
            const product = JSON.parse(el.textContent);
            if (product?.handle) subscribeProductCache[product.handle] = product;
        } catch (error) {
            console.error('Error parsing embedded product:', error);
        }
    });
}

function getSubscribeProduct(handle) {
    if (subscribeProductCache[handle]) {
        return Promise.resolve(subscribeProductCache[handle]);
    }
    if (subscribeProductPending[handle]) {
        return subscribeProductPending[handle];
    }
    subscribeProductPending[handle] = fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then((response) => response.json())
        .then((product) => {
            subscribeProductCache[handle] = product;
            delete subscribeProductPending[handle];
            return product;
        })
        .catch((error) => {
            delete subscribeProductPending[handle];
            throw error;
        });
    return subscribeProductPending[handle];
}

function prefetchSelectorProducts() {
    const handles = new Set();
    document.querySelectorAll('.featured-collections--selector [data-product-handle]').forEach((el) => {
        const handle = el.getAttribute('data-product-handle');
        if (handle) handles.add(handle);
    });
    handles.forEach((handle) => {
        getSubscribeProduct(handle).catch(() => {});
    });
}

function buildVariantOptions(variants, selectedId) {
    return variants.map((variant) => {
        const selected = String(variant.id) === String(selectedId) ? 'selected' : '';
        const label = formatPackLabel(variant);
        return variant.available && !DISABLED.includes(variant.sku)
            ? `<option value="${variant.id}" ${selected}>${label}</option>`
            : `<option value="${variant.id}" disabled>${label} - Sold Out</option>`;
    }).join('');
}

function buildPlanOptions(plans, selectedId) {
    return plans.map((plan) => {
        const selected = String(plan.id) === String(selectedId) ? 'selected' : '';
        return `<option value="${plan.id}" ${selected}>${formatFrequencyLabel(plan)}</option>`;
    }).join('');
}

function updateSubscribePrices(picker, product) {
    const variants = product?.variants || [];
    const plans = sellingPlans(product);
    const idField = picker.querySelector('[name="id"]');
    const variant = variants.find((entry) => String(entry.id) === String(idField?.value)) || pickSelectorVariant(variants);
    if (!variant) return;
    const planField = picker.querySelector('[name="selling_plan"]');
    const plan = plans.find((entry) => String(entry.id) === String(planField?.value)) || pickSelectorPlan(plans);
    const packSize = getPackSize(variant);
    const subPrice = getSubscriptionPrice(variant, plan);
    const listed = Number(variant.price) || 0;
    const compare = Number(variant.compare_at_price) || listed;
    const og = Math.max(listed, compare);

    const perBottle = picker.querySelector('#selector-price .per-bottle');
    const subtotalLabel = picker.querySelector('#selector-price .subtotal-label');
    const ogPriceEl = picker.querySelector('#selector-price .og-price');
    const newPriceEl = picker.querySelector('#selector-price .new-price');

    if (perBottle) perBottle.textContent = formatPrice(Math.round(subPrice / packSize));
    if (subtotalLabel) subtotalLabel.textContent = `Subtotal (${packSize} bottle${packSize === 1 ? '' : 's'})`;
    if (newPriceEl) newPriceEl.textContent = formatPrice(subPrice);
    if (ogPriceEl) {
        ogPriceEl.textContent = formatPrice(og);
        ogPriceEl.hidden = !(og > subPrice);
    }
}

function bindSelectorEvents(picker) {
    if (picker.dataset.selectorBound === 'true') return;
    picker.dataset.selectorBound = 'true';

    picker.addEventListener('change', (event) => {
        if (!event.target.matches('select')) return;
        const product = window.pickerProd;
        saveSelectorState(picker, product);
        updateSubscribePrices(picker, product);
    });

    picker.addEventListener('submit', (event) => {
        const form = event.target.closest('#selector-picker-form');
        if (!form) return;
        event.preventDefault();
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) submitButton.setAttribute('disabled', true);
        const formData = new FormData(form);
        const id = formData.get('id');
        const selling_plan = formData.get('selling_plan');
        addItemToCart(id, '1', selling_plan);
        openCart();
        window.setTimeout(() => {
            if (submitButton) submitButton.removeAttribute('disabled');
        }, 1200);
    });
}

function updateSelectorProductUI(picker, product) {
    const { name, sizeLabel } = selectorProductTitle(product);
    const img = picker.querySelector('.product-display img');
    const nameEl = picker.querySelector('.product-title__name');
    const sizeEl = picker.querySelector('.product-title__size');
    const image = productImage(product);
    if (img && image) {
        img.src = image;
        img.alt = product.title || '';
    }
    if (nameEl) nameEl.textContent = name;
    if (sizeEl) {
        sizeEl.textContent = sizeLabel;
        sizeEl.hidden = !sizeLabel;
    }

    const variants = product.variants || [];
    const plans = sellingPlans(product);
    const variant = pickSelectorVariant(variants);
    const plan = pickSelectorPlan(plans);

    const idWrap = picker.querySelector('.selector-case');
    if (idWrap) {
        if (variants.length > 1) {
            idWrap.innerHTML = `
                <label for="selector-id">1. Choose Case Size</label>
                <select name="id" id="selector-id">
                    ${buildVariantOptions(variants, variant?.id)}
                </select>`;
        } else {
            idWrap.innerHTML = `<input type="hidden" name="id" value="${variants[0]?.id || ''}">`;
        }
    }

    const freqWrap = picker.querySelector('.selector-freq');
    if (freqWrap) {
        if (plans.length) {
            freqWrap.hidden = false;
            freqWrap.innerHTML = `
                <label for="selector-selling-plan">2. Choose Frequency</label>
                <select name="selling_plan" id="selector-selling-plan">
                    ${buildPlanOptions(plans, plan?.id)}
                </select>`;
        } else {
            freqWrap.hidden = true;
            freqWrap.innerHTML = '';
        }
    }
}

function buildSelectorHTML(product) {
    const variants = product.variants || [];
    const plans = sellingPlans(product);
    const variant = pickSelectorVariant(variants);
    const plan = pickSelectorPlan(plans);
    const { name, sizeLabel } = selectorProductTitle(product);
    const image = productImage(product);
    const packSize = getPackSize(variant);
    const subPrice = getSubscriptionPrice(variant, plan);
    const listed = Number(variant?.price) || 0;
    const compare = Number(variant?.compare_at_price) || listed;
    const og = Math.max(listed, compare);
    const safeTitle = String(product.title || '').replace(/"/g, '&quot;');

    const caseSizeHTML = variants.length > 1
        ? `<label for="selector-id">1. Choose Case Size</label>
            <select name="id" id="selector-id">
                ${buildVariantOptions(variants, variant?.id)}
            </select>`
        : `<input type="hidden" name="id" value="${variants[0]?.id || ''}">`;

    const frequencyHTML = plans.length
        ? `<label for="selector-selling-plan">2. Choose Frequency</label>
            <select name="selling_plan" id="selector-selling-plan">
                ${buildPlanOptions(plans, plan?.id)}
            </select>`
        : '';

    return `
    <form method="post" action="/cart/add" class="active selector-picker-form" id="selector-picker-form">
        <p class="selector-heading">Your Selection</p>
        <div class="product-display">
            <div class="product-thumb">
                <img src="${image}" alt="${safeTitle}">
            </div>
            <p class="product-title">
                <span class="product-title__name">${name}</span>
                <span class="product-title__size"${sizeLabel ? '' : ' hidden'}>${sizeLabel}</span>
            </p>
        </div>
        <div class="selector-fields">
            <div class="selectWrap selector-case">${caseSizeHTML}</div>
            <div class="selectWrap selector-freq"${plans.length ? '' : ' hidden'}>${frequencyHTML}</div>
        </div>
        <input type="hidden" name="quantity" value="1">
        <div id="selector-price">
            <div class="selector-price-row">
                <span>Price per bottle</span>
                <span class="per-bottle">${formatPrice(Math.round(subPrice / packSize))}</span>
            </div>
            <div class="selector-price-row selector-price-row--subtotal">
                <span class="subtotal-label">Subtotal (${packSize} bottle${packSize === 1 ? '' : 's'})</span>
                <span class="selector-price-values">
                    <span class="og-price"${og > subPrice ? '' : ' hidden'}>${formatPrice(og)}</span>
                    <span class="new-price">${formatPrice(subPrice)}</span>
                </span>
            </div>
            <hr class="selector-price-divider">
            <p class="selector-shipping">Complimentary shipping on all subscriptions</p>
        </div>
        <button class="gold button" type="submit">Add to Cart</button>
        <p class="selector-footer">Easily manage or pause your subscription anytime.</p>
    </form>
    `;
}

function loadSubscribeSelector(product) {
    const picker = document.getElementById('selector');
    if (!picker) return;
    window.pickerProd = product;
    const form = picker.querySelector('#selector-picker-form');
    if (!form) {
        picker.innerHTML = buildSelectorHTML(product);
        bindSelectorEvents(picker);
    } else {
        updateSelectorProductUI(picker, product);
    }
    saveSelectorState(picker, product);
    updateSubscribePrices(picker, product);
}

function loadPicker(product, item = null, selector = false) {
    if (selector) {
        loadSubscribeSelector(product);
        return;
    }

    const plans = product?.selling_plan_groups?.[0]?.selling_plans;
    const hasPlans = plans && plans.length > 0;
    const variants = product.variants;

    const titleParts = product.title.split('(');
    let displayTitle = `<span class="product-title__name"><h2>${titleParts[0].trim()}</h2></span>`;
    if (product.type) displayTitle += `<br>${product.type}`;
    if (titleParts[1]) displayTitle += `<br>(${titleParts[1]}`;
    window.pickerProd = product;

    const ogPrice = formatPrice(variants[variants.length - 1].price);
    const newPrice = hasPlans ? calculatePrice(variants[variants.length - 1].price, plans[0]) : ogPrice;
    const productImageUrl = productImage(product);

    const headerHTML = `<div class="picker__header">
    <h2 class="drawer__heading">Add to Cart</h2>
    <button class="drawer__close" type="button" onclick="this.closest('cart-drawer').close()" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </button>
  </div>`;

    const frequencySelect = hasPlans ? `
      <select name="selling_plan" id="selling_plan">
          ${plans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
      </select>
  ` : '';

    const frequencyHTML = `
  <label for="selling_plan">Delivery Frequency</label>
      ${frequencySelect}
  `;

    const quantityHTML = `<label for="quantity" class="desktopLabel">Quantity</label>
  <label for="quantity" class="mobileLabel">Qty</label>
  <select name="quantity" id="quantity">
      <option value="1" selected>1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
      <option value="8">8</option>
      <option value="9">9</option>
      <option value="10">10</option>
  </select>`;

    const variantOptions = variants.map((variant, index) => {
        let title = variant.title.split('L ');
        title = title[title.length - 1];
        title = title.includes(' Pack') ? title.replace(' Pack', '-Pack Case') : title;
        const selected = index === variants.length - 1 ? 'selected' : '';
        return variant.available && !DISABLED.includes(variant.sku)
            ? `<option value="${variant.id}" ${selected}>${title}</option>`
            : `<option value="${variant.id}" disabled>${title} - Sold Out</option>`;
    }).join('');

    const caseSizeHTML = variants.length > 1 ? `
                <label for="id">Case Size</label>
                    <select name="id" id="id">
                        ${variantOptions}
                    </select>
                ` : `<input type="hidden" name="id" value="${variants[0]?.id || ''}">`;

    const pickerHTML = `
        <form method="post" action="/cart/add" class="active" id="product-picker-form">
        ${headerHTML}
        <div class="product-display">
            <img src="${productImageUrl}&width=100" alt="${product.title.replace(/"/g, '&quot;')}">
            <div class="product-title">${displayTitle}</div>
        </div>
            ${hasPlans ? `
            <div id="picker_boxes">
                    <div class="picker_box active" id="picker_box_subscription">
                        <h4>Subscribe & Save</h4>
                        <p class="price"><span class="amount">${newPrice}</span><span class="per">/ case</span></p>
                    </div>
                    <div class="picker_box" id="picker_box_one_time">
                        <h4>One Time Purchase</h4>
                        <p class="price"><span class="amount">${ogPrice}</span><span class="per">/ case</span></p>
                    </div>
                </div>
                
            ` : ''}
            <div class="row">
                <div class="selectWrap">${caseSizeHTML}</div>
                <div class="selectWrap small">${quantityHTML}</div>
            </div>
            <div class="row">
                <div class="freq active selectWrap">${frequencyHTML}</div>
            </div>
            

            <button class="gold button" type="submit">Add to Cart</button>
        </form>
        `;

    const picker = document.getElementById('picker-wrapper');
    if (!picker) return;
    picker.innerHTML = pickerHTML;
    if (document.querySelector('cart-drawer')?.classList.contains('active')) {
        trapFocus(picker, picker.querySelector('.drawer__close'));
    }
    const close = document.querySelector('.close_picker');
    if (close) close.addEventListener('click', closePicker);

    const updatePrices = () => {
        const idField = picker.querySelector('[name="id"]');
        const variant = variants.find((entry) => String(entry.id) === String(idField?.value)) || variants[variants.length - 1];
        const price = variant.price;
        const planField = picker.querySelector('[name="selling_plan"]');
        const sellingPlan = hasPlans ? plans.find((plan) => String(plan.id) === String(planField?.value)) || plans[0] : null;
        const isOneTime = picker.querySelector('.picker_box.active')?.id?.includes('one_time');
        const discountPrice = (format = true) => (sellingPlan ? calculatePrice(price, sellingPlan, format) : (format ? formatPrice(price) : price));
        const oneTimeAmount = picker.querySelector('#picker_box_one_time .price .amount');
        const subscriptionAmount = picker.querySelector('#picker_box_subscription .price .amount');
        if (subscriptionAmount) subscriptionAmount.innerHTML = discountPrice();
        if (oneTimeAmount) oneTimeAmount.innerHTML = formatPrice(price);
    };

    picker.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', updatePrices);
    });

    const productForm = picker.querySelector('#product-picker-form');
    if (productForm) {
        productForm.addEventListener('submit', function (event) {
            event.preventDefault();
            const submitButton = picker.querySelector('button[type="submit"]');
            if (submitButton) submitButton.setAttribute('disabled', true);
            const isOneTime = picker.querySelector('#picker_box_one_time')?.classList.contains('active');
            const formData = new FormData(this);
            const id = formData.get('id');
            const quantity = formData.get('quantity');
            const selling_plan = isOneTime ? null : formData.get('selling_plan');
            addItemToCart(id, quantity, selling_plan);
        });
    }

    picker.querySelectorAll('.picker_box').forEach((box) => {
        box.addEventListener('click', function () {
            const subscription = picker.querySelector('#picker_box_subscription');
            const oneTime = picker.querySelector('#picker_box_one_time');
            const frequencyPicker = picker.querySelector('.freq');
            const isSubscription = box.id === 'picker_box_subscription';
            if (isSubscription) {
                subscription?.classList.add('active');
                oneTime?.classList.remove('active');
                frequencyPicker?.classList.add('active');
            } else {
                subscription?.classList.remove('active');
                oneTime?.classList.add('active');
                frequencyPicker?.classList.remove('active');
            }
            updatePrices();
        });
    });

    updatePrices();
}

function scrollToSubscribeOptions() {
    if (!window.matchMedia('(max-width: 990px)').matches) return;
    const picker = document.getElementById('selector');
    if (!picker) return;
    picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function markSelectorProduct(handle) {
    document.querySelectorAll('.featured-collections--selector .product-picker-trigger.button').forEach((el) => {
        el.classList.remove('active');
        el.textContent = 'SELECT';
    });
    document.querySelectorAll('.featured-collections--selector .product-picker-trigger').forEach((el) => {
        el.classList.remove('active');
    });
    document.querySelectorAll('.featured-collections--selector .product').forEach((el) => {
        el.classList.remove('is-selected');
    });
    document.querySelectorAll(`.featured-collections--selector .product-picker-trigger[data-product-handle="${handle}"]`).forEach((el) => {
        el.classList.add('active');
        el.closest('.product')?.classList.add('is-selected');
        if (el.classList.contains('button')) {
            el.textContent = 'SELECTED';
        }
    });
}

function selectFirstSelectorProduct(root, collectionId) {
    if (!root) return;
    let slide = root.querySelector('.slider__slide');
    if (collectionId) {
        slide = root.querySelector(`.slider__slide[data-collection="${collectionId}"]`) || slide;
    } else {
        const slider = root.querySelector('.slider');
        const slides = root.querySelectorAll('.slider__slide');
        if (slider && slides.length) {
            const offset = slides[0].offsetWidth || 1;
            const index = Math.round((slider.scrollLeft || 0) / offset);
            slide = slides[index] || slides[0];
        }
    }
    const button = slide?.querySelector('.product-picker-trigger.selector.button, .product-picker-trigger.selector[data-product-handle]');
    const handle = button?.getAttribute('data-product-handle');
    if (!handle) return;
    const trigger = slide.querySelector(`.product-picker-trigger.selector.button[data-product-handle="${handle}"]`) || button;
    trigger?.click();
}

document.addEventListener('DOMContentLoaded', function () {
    cacheEmbeddedSelectorProducts();
    prefetchSelectorProducts();

    document.body.addEventListener('click', function (event) {
        const trigger = event.target.closest('.product-picker-trigger');
        const selector = trigger?.classList.contains('selector');
        if (!trigger) return;

        event.preventDefault();

        if (selector) {
            const handle = trigger.getAttribute('data-product-handle');
            const alreadySelected = trigger.classList.contains('active') && document.getElementById('selector-picker-form');
            markSelectorProduct(handle);
            if (event.isTrusted) scrollToSubscribeOptions();
            if (alreadySelected) return;

            const cached = subscribeProductCache[handle];
            if (cached) {
                loadSubscribeSelector(cached);
                return;
            }

            getSubscribeProduct(handle)
                .then((product) => loadSubscribeSelector(product))
                .catch((error) => console.error('Error loading product:', error));
            return;
        }

        openPicker(trigger.matches("button") ? trigger : trigger.closest(".simple-card")?.querySelector("button.product-picker-trigger") || trigger);

        const handle = trigger.getAttribute('data-product-handle');
        const itemKey = trigger.getAttribute('data-item-key') || null;

        fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
            .then((response) => response.json())
            .then((product) => {
                if (itemKey) {
                    fetch(window.Shopify.routes.cart_url + '.js').then((response) => response.json()).then((cart) => {
                        window.cart = cart;
                        const item = cart.items.find((entry) => entry.key === itemKey);
                        window.item = item;
                        loadPicker(product, item);
                    });
                } else {
                    loadPicker(product);
                }
            })
            .catch((error) => console.error('Error loading product:', error));
    });

    document.querySelectorAll('.featured-collections--selector').forEach((root) => {
        selectFirstSelectorProduct(root);
    });

    document.addEventListener('collection-change', (event) => {
        const root = event.target.closest('.featured-collections--selector');
        if (!root) return;
        selectFirstSelectorProduct(root, event.detail?.collectionId);
    });
});
